/* src/app/modules/shared/components/column/column-primary-price/column-primary-price.component.scss */
app-column-primary-price {
  display: contents;
}
/*# sourceMappingURL=column-primary-price.component.css.map */
